/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
import cx from "clsx";
import { Tooltip } from "../../../shared/Tooltip/Tooltip";
import picClose from "../../../_legacy/images/popupClose.png";
import styles from "./scss/StaffReportTitle.module.scss";

export default class StaffReportTitle extends Component {
  constructor(props) {
    super(props);

    const languageData = JSON.parse(localStorage.getItem("languageData"));

    this.state = {
      showLoader: false,
      globalLang: languageData.global,
      languageData: languageData.business_insights,
      showInfo: false,
    };
  }

  showInfo = () => {
    this.setState({ showInfo: true });
  };

  hideInfo = () => {
    this.setState({ showInfo: false });
  };

  showCreateOptions = () => {
    this.props.showCreateOptions();
  };

  saveReport = () => {
    this.props.saveReport();
  };

  render() {
    const formula = this.props.parentState.formula;

    return (
      <div className="membership-title">
        {this.state.showInfo && (
          <div className="blackOverlay">
            <div className="vert-middle vert-middle-report-option">
              <div className="white-popup large-popup">
                <div className="white-popup-wrapper">
                  <div className="membershipTypeTitle">
                    Provider Roll Up - Calculation Help
                    <a onClick={this.hideInfo} className="popupClose">
                      <img src={picClose} alt="" />
                    </a>
                  </div>
                  <div className="row">
                    <div className={cx("col-sm-12", styles.formulaContainer)}>
                      {formula &&
                        formula.map((row, idx) => (
                          <p key={idx}>
                            <b>{row.label}:</b> {row.description}
                          </p>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.props.parentState.grammar && (
          <div className={"col-sm-12 m-b-10"}>
            <span className="flex gap-8 text-no-wrap">
              {this.props.parentState.grammar}
              {this.props.parentState.grammar.indexOf("Busiest Day") !== -1 && (
                <Tooltip
                  id="busiest-day-tip"
                  text={
                    '<strong>Booked Appointments:</strong> Total appointments scheduled (including cancelled/no-shows, excluding out-of-office)<br/><br/><strong>Completed Appointments:</strong> Appointments where clients were checked in via the appointment card<br/><br/><strong>Procedure Sales:</strong> Full payments for procedures only (excludes partial payments and refunds)<br/><br/><strong>Quickpay Sales:</strong> "Take Payment" transactions for retail, services, and promotions (excludes gift cards, cancellation fees, memberships, staff treatments, and deposits)'
                  }
                  withHtmlEntities
                  className="d-inline-block m-l-10"
                  size="lg"
                  place="bottom"
                  clickable
                  delayHide={150}
                >
                  <i className="fa fa-info-circle" aria-hidden="true" />
                </Tooltip>
              )}
              {formula &&
                this.props.parentState.grammar.indexOf("Provider Roll Up") !==
                  -1 && (
                  <span onClick={this.showInfo} className="infoIcon">
                    <i className="fa fa-info-circle" />
                  </span>
                )}
            </span>
          </div>
        )}

        {!this.props.parentState.showLoader && (
          <div className="memberRightActions">
            {this.props.parentState.reportListData &&
              this.props.parentState.reportListData.length > 0 && (
                <a
                  onClick={() => this.props.downloadData()}
                  className="easy-link no-padding"
                >
                  <i className="fa fa-download m-r-5" />
                  {this.props.parentState.businessInsightLang.bi_download_excel}
                </a>
              )}

            {this.props.parentState.reportType !== "view" && (
              <a
                className="easy-link no-padding"
                onClick={this.showCreateOptions}
              >
                <i className="fa fa-pencil-alt m-r-5" />{" "}
                {this.props.parentState.businessInsightLang.bi_edit}
              </a>
            )}
            {this.props.parentState.dataLoadedOnce === true &&
              this.props.parentState.reportType !== "view" && (
                <a className="new-blue-btn" onClick={this.saveReport}>
                  {this.props.parentState.businessInsightLang.bi_save_report}
                </a>
              )}
          </div>
        )}
      </div>
    );
  }
}
